/**
 * Добавляет GET параметр к url
 * @param {string} url
 * @param {string} key
 * @param {string} value
 * @returns {string}
 */
const modifyUrl = (url: string, key: string, value: string): string => {
    if (typeof url !== 'string') return '';
    if (url.length === 0) return '';

    const { origin, pathname, search } = new URL(url);
    const params = new URLSearchParams(search);

    params.set(key, value);

    return `${origin}${pathname}?${params.toString()}`;
};

export default modifyUrl;
